<app-customer-account-dialog id="createAlert">
    <div id="content">
        <div class="overlay filterData">
            <div class="overlay-header">
                <h3>Create Alert</h3>
                <div class="close-btn">
                    <button mat-icon-button mat-dialog-close (click)="closeCreateAlert()">
                        <i class="fa-sharp fa-regular fa-xmark-large"></i>
                    </button>
                </div>
            </div>
            <div class="section-divider"></div>
        <form id="alert-form" [formGroup]="createAlertForm" (ngSubmit)="onSubmit()">
            
            <!-- Error Alert is in hidden mode, can be used by Features when required. -->
            <f-alert variant="error" *ngIf="isAlertTypesAPIError" class="status-msg hide1">{{alertTypesErrMsg}} <a
                    href="javascript:void('0')" (click)="getAlertTypes()">Try
                    again</a></f-alert>
            <f-alert variant="error" *ngIf="isCreateAPIError" class="status-msg hide1">{{createAlertErrMsg}}</f-alert>

            <div class="form-scroll">
                <div class="overlay-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill" class="component-box">
                                    <mat-label>Type (Required)</mat-label>
                                    <mat-select disableRipple disableOptionCentering disableRipple formControlName="alertType"
                                        disableOptionCentering>
                                        <mat-option *ngFor="let alertType of alertTypes" [value]="alertType.type"
                                            (onSelectionChange)="subTypeAlerts(alertType,$event)">
                                            {{ alertType.type }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
              <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Subtype (Required)</mat-label>
                        <mat-select disableRipple disableOptionCentering disableRipple formControlName="alertSubType"
                            disableOptionCentering>
                            <mat-option *ngFor="let alertSubType of alertSubTypes" [value]="alertSubType.subType"
                                (onSelectionChange)="alertSubTypeSelection(alertSubType,$event)">
                                {{ alertSubType.subType }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
              </div>
                <!-- <app-alight-drop-down class="alert-dropdown" [group]="customerAccForm" [list]="alertTypes" value="type"
                description="type" label="Type (Required)" (change)="subTypeAlerts($event)"></app-alight-drop-down> -->
             
                <!-- <app-alight-drop-down [group]="customerAccForm" value="fieldValue" description="fieldValueDescription"
                label="Subtype (Required)"></app-alight-drop-down> -->

                <!-- use this input box headlines input 
                  
                  <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Headlines</mat-label>
                      <input matInput formControlName="headlines" id="headlines" />
        </mat-form-field>
        -->
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill" class="component-box">
                    <mat-label>Title (Required)</mat-label>
                    <input matInput formControlName="title" [maxlength]="100" />
                </mat-form-field>
            </div>
        </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Details (Required)</mat-label>
                        <textarea matInput cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" #description class="long-text"
                            [maxlength]="1000" formControlName="description"></textarea>
                    </mat-form-field>
                </div>
            </div>    
                <div class="row">
                    <div class="col-md-12">
                        <div class="char-count">
                            <span class="letter-count">{{description.value.length}}/1000</span>
                        </div>
                    </div>
                </div>
                

                <div class="row">
                    <div class="col-md-6 flex">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label>Start Date (MMM-DD-YYYY)</mat-label>
                            <input matInput [matDatepicker]="picker1" [min]="todayDate" [max]="maxDate"
                                formControlName="start" (dateChange)="addEvent( $event)" />
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    
                    <div class="col-md-6 flex">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label>End Date (MMM-DD-YYYY)</mat-label>
                            <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxDate"
                                formControlName="end" />
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                    
                </div>
            </div>
            </div>
            </div>
        
            <div class="button-controls">
                <f-button text="Cancel" variant="action" mat-dialog-close (click)="closeCreateAlert()"></f-button>
                <f-button text="Create" type="submit" [disabled]="createAlertForm.invalid"
                    variant="progressive"></f-button>
            </div>
        </form>
            <app-loader *ngIf="showLoader" [loaderType]="loaderType" [loaderMsg]="showLoader"></app-loader>
        
        </div>
    </div>
</app-customer-account-dialog>

